import CisionPressReleasePage from './CisionPressReleasePage';

export default CisionPressReleasePage;
